import { createTheme } from '@mui/material/styles';

// Create a custom Material-UI theme with Roboto font and left alignment
const theme = createTheme({
  typography: {
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif'
    ].join(','),
    h1: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    h2: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    h3: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    h4: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    h5: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    h6: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    body1: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    body2: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    button: {
      fontFamily: 'Roboto, sans-serif',
    },
    caption: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
    overline: {
      fontFamily: 'Roboto, sans-serif',
      textAlign: 'left',
    },
  },
  components: {
    // Override Material-UI components to use left alignment by default
    MuiTypography: {
      styleOverrides: {
        root: {
          textAlign: 'left',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          textAlign: 'left',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          textAlign: 'left',
        },
      },
    },
  },
});

export default theme;